module.exports = __webpack_public_path__ + "img/up.b6988c89.svg";